export default (boolean) => {
  return boolean ? "Sim" : "Não";
};
